import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, skip, takeUntil } from 'rxjs/operators';
import { MemberPortalSharedState } from 'src/app/modules/shared/store/shared.states';
import { RecordConsentAction } from '../actions';
import {
  greenId_ConsentCompletedDate,
  greenId_ConsentForm,
  greenId_ConsentSaving,
} from '../selectors';

@Component({
  selector: 'greenid-consent-dialog',
  templateUrl: './consent-dialog.component.html',
  styleUrls: ['./consent-dialog.component.scss'],
})
export class GreenIdConsentDialog implements OnInit, OnDestroy {
  form$ = this.store.pipe(select(greenId_ConsentForm));

  consentSavingSelector = greenId_ConsentSaving;

  private destroying$ = new Subject<void>();

  constructor(
    public store: Store<MemberPortalSharedState>,
    public dialogRef: MatDialogRef<GreenIdConsentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(
        select(greenId_ConsentCompletedDate),
        distinctUntilChanged(),
        skip(1),
        filter((date) => !!date),
        takeUntil(this.destroying$)
      )
      .subscribe(() => this.dialogRef.close('agree'));
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }

  onAgreeClick(): void {
    this.store.dispatch(
      RecordConsentAction({
        account: this.data.accountId,
        verificationId: this.data.verificationId,
      })
    );
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
